// extracted by mini-css-extract-plugin
export default {"voteOptionContainer":"VoteOptionStyles_voteOptionContainer__2NFOi","smMarginTop":"VoteOptionStyles_smMarginTop__Lmxca","selected":"VoteOptionStyles_selected__uAWhI"};